import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { commonFormStyles, commonLHCOmponentStyle } from '@ahoy/ui/common/styles/common-styles';
import { QuestionsService } from '@APP/services/questions-service';
import { UserService } from '@APP/services/user-service';
import { customElement, property, state } from 'lit/decorators';
import { DeviceAwareComponent } from './device-aware-component';
import { html, css, PropertyValues, nothing } from 'lit';
import { Question } from '@APP/model/question';
import { t } from '@APP/utils/locale';

type OwnDeps = {
  questionsService: QuestionsService;
  userService: UserService;
};

@requires(QuestionsService.serviceName, UserService.serviceName)
@customElement('lh-allready-registered')
export class LHAlreadyRegistered extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {

  static get baseStyles() {
    return [
      commonLHCOmponentStyle(css),
      commonFormStyles(css),
      css`
        :host([hidden]) {
          display: none;
      }
      :host {
        font-size: 2.5rem;
        display: grid;
        grid-gap: 2rem;
      }
      .text-message{
        color: var(--c-text);
      }
      a {
        color: var(--c-link);
        text-decoration: underline;
        cursor: pointer;
        width: fit-content;
        padding: 1rem;
      }
    `,
    ];
  };

  static get mobileStyles() {
    return [
      css`
        :host {
          text-shadow: 1px 1px white;
          margin-bottom: 4rem;
        }
      `,
    ];
  }

  static get desktopStyles() {
    return [
      css`
        :host {
        margin-top: -3rem;
      }

      div.text-wrapper{
        display: flex;
        align-items: center;
      }
      div.text-wrapper :is(a,span.text-message){
        white-space: nowrap;
      }
    `,
    ];
  }

  @property({ type: String, attribute: 'question-id' })
    questionId = '';

  @state()
    question: Question | undefined;

  constructor() {
    super();
  }

  updated(p: PropertyValues<this>) {

    if (p.has('questionId')) {
      this.question = this.deps.questionsService.model.getQuestionById(this.questionId) as Question | undefined;
    }

  }

  signin() {
    this.deps.userService.saveOtpTracking('change-to-login', '', '');
    /** Send S_Welcome data before login to gtm */
    this.deps.userService.sendWebtrackingData('change-to-login', '');
    this.deps.userService.changeLoginMode('login');
  }

  renderContent() {
    const isLoogedIn = this.deps.userService?.isLoggedIn;
    if (!this.question || isLoogedIn) {
      return nothing;
    }
    return html`
      <div class="text-wrapper">
        <span class="text-message">${t('T_Allready_Registered')}</span>
        <a link pop @click=${this.signin}>
              ${t('T_SignIn_Here')}
          </a>
      </div>
    `;
  }

}